import script from "./msgGift.vue?vue&type=script&setup=true&name=msgGift&lang=js"
export * from "./msgGift.vue?vue&type=script&setup=true&name=msgGift&lang=js"

import "./msgGift.vue?vue&type=style&index=0&id=6e10d621&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e10d621"]])

export default __exports__